import { Component, Input, OnInit } from "@angular/core";
import { Utilities } from "@tylertech/shared-module";
import { PurchaseOrderInvoiceViewModel } from "@tylertech/tyler-api-types";

/**
 * @deprecated I think this has been replaced by a MetadataAction in the backend.
 * TODO - Confirm and Remove.
 */
@Component({
    selector: "invoice-history",
    templateUrl: "./poInvoiceHistory.tmpl.html",
    standalone: false
})
export class InvoiceHistoryComponent implements OnInit
{
    @Input() invoices: PurchaseOrderInvoiceViewModel[];

    public total = <PurchaseOrderInvoiceViewModel>{
        Amount: 0,
        SalesTax: 0,
        Shipping: 0,
        InTotal: 0,
    };

    usePaymentDate: boolean = true;

    usePaymentNumber: boolean = true;

    useShipping: boolean = true;

    useTax: boolean = true;

    useUnit: boolean = true;

    ngOnInit(): void
    {
        this.setTotals();
        this.checkUse();
    }

    checkUse(): void
    {
        if (this.hasInvoices)
        {
            this.useShipping = this.invoices.filter(x => !Utilities.IsNullOrUndefinedOrZero(x.Shipping)).length > 0;
            this.useTax = this.invoices.filter(x => !Utilities.IsNullOrUndefinedOrZero(x.SalesTax)).length > 0;
            this.useUnit = this.invoices.filter(x => !Utilities.IsNullOrUndefinedOrZero(x.Units)).length > 0;
            this.usePaymentDate = this.invoices.filter(x => !Utilities.IsNullOrUndefined(x.PaidDate)).length > 0;
            this.usePaymentNumber =
                this.invoices.filter(x => !Utilities.IsNullOrUndefinedOrEmpty(x.PaymentNumber)).length > 0;
        }
    }

    hasInvoices(): boolean
    {
        return !Utilities.IsNullOrUndefined(this.invoices) && this.invoices.length > 0;
    }

    setTotals(): void
    {
        this.invoices.forEach(element =>
        {
            this.total.Amount = this.total.Amount + element.Amount;
            this.total.SalesTax = this.total.SalesTax + element.SalesTax;
            this.total.Shipping = this.total.Shipping + element.Shipping;
            this.total.InTotal = this.total.InTotal + element.InTotal;
        });
    }
}
